export default __webpack_public_path__ + "43706a2883eb57c7928494da07b0bf70.ttf";